export default __webpack_public_path__ + "static/media/groupe-785.ca3fe35f.jpg";